// extracted by mini-css-extract-plugin
export default {"badge":"badge_new__badge--H2tu","sm":"badge_new__sm--+2gX"};